/* eslint-disable array-callback-return */

import _ from "lodash";
import React, {useEffect, useState} from "react";
import {Badge, Button, Col, Form, Modal, Row, Spinner, Table} from "react-bootstrap";
import {BiEdit, BiTrash} from "react-icons/bi";
import {Get, Post} from "../../lib/Request";
import {ALERT_VARIANT} from "../../const/dataEnum";
import {setAlert} from "../../stores/actions/alertModalStateAction";
import {useDispatch} from "react-redux";
import {API_ACTION, API_REVIEW_PERIOD} from "../../const/Api";
import {ConsoleLog} from "../../lib/ConsoleHelper";
import Asterisk from "../../components/Asterisk";

export default function ManagePeriods() {
  const dispatch = useDispatch();

  const defaultPeriod = {
    id: 0,
    period: "",
    isActive: false,
    startDate: null,
    endDate: null,
  };

  // Period
  const [loadingPeriods, setLoadingPeriods] = useState(true);
  const [periods, setPeriods] = useState([]);
  const [activePeriodID, setActivePeriodID] = useState(0);
  const [selectedPeriod, setSelectedPeriod] = useState(defaultPeriod);

  //
  const [action, setAction] = useState("");
  const [loadingModify, setLoadingModify] = useState(false);

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      fetchPeriods().then();
    }
    return function cleanup() {
      mounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function callError(result) {
    if (result.responseCode !== 0) {
      dispatch(
        setAlert({
          show: true,
          variant: ALERT_VARIANT.ERROR,
          message: result.message,
        })
      );
      return true;
    }
    return false;
  }

  async function fetchPeriods() {
    setLoadingPeriods(true);
    let result = await Get(API_REVIEW_PERIOD);
    if (!callError(result)) {
      await setPeriods(result.data);
      result.data.map((period) => {
        if (period.isActive) setActivePeriodID(period.id);
      });
    }
    setLoadingPeriods(false);
  }

  async function ModifyPeriod(event) {
    event.preventDefault();
    setLoadingModify(true);
    let url;
    // eslint-disable-next-line default-case
    switch (action) {
      case "Create":
        url = API_REVIEW_PERIOD + API_ACTION.CREATE;
        break;
      case "Update":
        url = API_REVIEW_PERIOD + API_ACTION.UPDATE;
        break;
      case "Delete":
        url = API_REVIEW_PERIOD + API_ACTION.DELETE;
        break;
    }
    let result = await Post(url, selectedPeriod);
    if (!callError(result)) {
      dispatch(
        setAlert({
          show: true,
          variant: ALERT_VARIANT.SUCCESS,
          message: result.message,
        })
      );
      await fetchPeriods();
    } else if (result.responseCode === -9) {
      dispatch(
        setAlert({
          show: true,
          variant: ALERT_VARIANT.ERROR,
          message: "The data is being used somewhere else",
        })
      );
    } else {
      dispatch(
        setAlert({
          show: true,
          variant: ALERT_VARIANT.ERROR,
          message: result.message,
        })
      );
    }
    setAction("");
    setSelectedPeriod(defaultPeriod);
    setLoadingModify(false);
  }

  async function ActivatePeriod() {
    setLoadingModify(true);

    let oldPeriod = periods.find((period) => period.id === activePeriodID);

    if (oldPeriod === null) {
      oldPeriod = periods.find((period) => period.id !== selectedPeriod.id);
    }
    oldPeriod.isActive = false;
    let newPeriod = periods.find((period) => period.id === selectedPeriod.id);
    newPeriod.isActive = true;

    let url = API_REVIEW_PERIOD + API_ACTION.UPDATE;
    let oldPeriodActionResult = await Post(url, oldPeriod);
    if (!callError(oldPeriodActionResult)) {
      let newPeriodActionResult = await Post(url, newPeriod);
      if (!callError(newPeriodActionResult)) {
        dispatch(
          setAlert({
            show: true,
            variant: ALERT_VARIANT.SUCCESS,
            message: newPeriodActionResult.message,
          })
        );

        await fetchPeriods();
      } else {
        dispatch(
          setAlert({
            show: true,
            variant: ALERT_VARIANT.ERROR,
            message: oldPeriodActionResult.message,
          })
        );
      }
    } else {
      dispatch(
        setAlert({
          show: true,
          variant: ALERT_VARIANT.ERROR,
          message: oldPeriodActionResult.message,
        })
      );
    }
    setAction("");
    setSelectedPeriod(defaultPeriod);
    setLoadingModify(false);
  }

  const areAllFieldFilled = () => {
    if (
      (selectedPeriod?.period?.length > 0 &&
        selectedPeriod?.period?.length <= 6 &&
        selectedPeriod?.startDate &&
        selectedPeriod?.endDate) ||
      loadingModify
    ) {
      return true;
    }
    return false;
  };

  const isButtonSaveDisabled = !areAllFieldFilled();

  const showAsterisk = (value) => {
    if (!value) {
      return <Asterisk/>;
    }
    return <></>;
  };

  const body = (
    <div className="container py-4">
      <Button onClick={() => setAction("Create")}>Add Period</Button>
      <Table hover>
        <thead>
        <tr>
          <th>#</th>
          <th>Period Name</th>
          <th>Period Status</th>
          <th>Action</th>
        </tr>
        </thead>
        <tbody>
        {loadingPeriods ? (
          <tr>
            <td className="text-center" colSpan="4">
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            </td>
          </tr>
        ) : periods.length === 0 ? (
          <tr>
            <td className="text-center" colSpan="4">
              No Data Available
            </td>
          </tr>
        ) : (
          periods.map((pd, index) => {
            pd = {
              ...pd,
              startDate: pd?.startDate?.split("T")[0],
              endDate: pd?.endDate?.split("T")[0],
            };
            return (
              <tr key={pd.id}>
                <td>{index + 1}</td>
                <td>{pd.period}</td>
                <td>
                  <Badge bg={pd.isActive ? "primary" : "secondary"}>{pd.isActive ? "Active" : "Inactive"}</Badge>
                </td>
                <td>
                  <div style={{display: "flex", gap: "8px"}}>
                    {!pd.isActive && (
                      <Button
                        onClick={() => {
                          setSelectedPeriod(_.cloneDeep(pd));
                          setAction("Activate");
                        }}
                      >
                        Make&nbsp;Active
                      </Button>
                    )}
                    <Button
                      onClick={() => {
                        setSelectedPeriod(_.cloneDeep(pd));
                        setAction("Update");
                      }}
                    >
                      <BiEdit/>
                    </Button>
                    {!pd.isActive && (
                      <Button
                        variant="danger"
                        onClick={() => {
                          setSelectedPeriod(_.cloneDeep(pd));
                          setAction("Delete");
                        }}
                      >
                        <BiTrash/>
                      </Button>
                    )}
                  </div>
                </td>
              </tr>
            );
          })
        )}
        </tbody>
      </Table>
    </div>
  );

  const deletePrompt = (
    <Modal show={action === "Delete"} centered size="md" aria-labelledby="contained-modal-title-vcenter">
      <Modal.Header>
        <Modal.Title>Delete Period</Modal.Title>
      </Modal.Header>
      <Modal.Body>Are you sure to delete this period?</Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={ModifyPeriod} disabled={loadingModify}>
          {loadingModify ? (
            <div>
              <span
                style={{marginLeft: "0px"}}
                className="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
            </div>
          ) : (
            "Yes"
          )}
        </Button>
        <Button
          variant="secondary"
          onClick={() => {
            setAction("");
            setSelectedPeriod(defaultPeriod);
          }}
        >
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );

  const createOrUpdatePrompt = (
    <Modal
      show={["Create", "Update"].includes(action)}
      centered
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
    >
      <Form onSubmit={ModifyPeriod}>
        <Modal.Header>
          <Modal.Title>{action} Period</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Row>
            <Col>
              <Form.Group size="lg" controlId="periodName" className="mb-2">
                <Form.Label>Period Name (max. 6 characters allowed){showAsterisk(selectedPeriod.period)}</Form.Label>
                <Form.Control
                  autoFocus
                  placeholder="Period"
                  type="text"
                  value={selectedPeriod.period}
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    if (inputValue.length <= 6) {
                      setSelectedPeriod({
                        ...selectedPeriod,
                        period: inputValue,
                      });
                    }
                  }}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group size="lg" controlId="periodStartDate" className="mb-2">
                <Form.Label>Start Date{showAsterisk(selectedPeriod.startDate)}</Form.Label>
                <Form.Control
                  required
                  autoFocus
                  type="date"
                  value={selectedPeriod.startDate}
                  max={selectedPeriod.endDate}
                  onChange={(e) =>
                    setSelectedPeriod({
                      ...selectedPeriod,
                      startDate: e.target.value,
                    })
                  }
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group size="lg" controlId="periodEndDate" className="mb-2">
                <Form.Label>End Date{showAsterisk(selectedPeriod.endDate)}</Form.Label>
                <Form.Control
                  required
                  autoFocus
                  type="date"
                  min={selectedPeriod.startDate}
                  value={selectedPeriod.endDate}
                  onChange={(e) => {
                    setSelectedPeriod({
                      ...selectedPeriod,
                      endDate: e.target.value,
                    });
                    ConsoleLog(selectedPeriod);
                  }}
                />
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>

        <Modal.Footer>
          <Button size="md" type="submit" style={{width: "150px"}} disabled={isButtonSaveDisabled}>
            {loadingModify ? (
              <div>
                <span
                  style={{marginLeft: "0px"}}
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
              </div>
            ) : (
              "Save Changes"
            )}
          </Button>

          <Button
            variant="secondary"
            onClick={() => {
              setAction("");
              setSelectedPeriod(defaultPeriod);
            }}
            disabled={loadingModify}
          >
            Close
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );

  const makeActivePrompt = (
    <Modal show={action === "Activate"} centered size="md" aria-labelledby="contained-modal-title-vcenter">
      <Modal.Header>
        <Modal.Title>Set Period As Active</Modal.Title>
      </Modal.Header>
      <Modal.Body>Are you sure to set this period as active?</Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={ActivatePeriod} disabled={loadingModify}>
          {loadingModify ? (
            <div>
              <span
                style={{marginLeft: "0px"}}
                className="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
            </div>
          ) : (
            "Yes"
          )}
        </Button>
        <Button
          variant="secondary"
          onClick={() => {
            setAction("");
            setSelectedPeriod(defaultPeriod);
          }}
        >
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );

  return (
    <div className="container">
      {body}
      {deletePrompt}
      {createOrUpdatePrompt}
      {makeActivePrompt}
    </div>
  );
}
